export default __webpack_public_path__ + "static/media/Comp 2_00041.8e0051a5.png";